/**
 * Auth methods
 */
import { api } from '../api'

const AuthAPI = () => {
    return {
        signin,
        twofa,
        signout,
        getCurrentUser,
        updateUserInfo,
        updateUserPassword
    }

    /**
     * Sign a user in
     * @param {string} email user email
     * @param {string} password user password
     */
    async function signin(email, password) {
        const url = '/api/scrapery/login'
        const data = {
            email,
            password
        }

        const result = await api.post(url, data)
        // check for errors 
        const { detail } = result
        if (detail) {
            throw new Error(detail)
        }

        return result.message
    }

    /**
     * 2FA for a user
     * @param {string} code 2fa code
     */
    async function twofa(code) {
        const url = '/api/scrapery/2fa'
        const data = {
            code
        }

        const result = await api.post(url, data)
        // check for errors 
        const { detail } = result
        if (detail) {
            throw new Error(detail)
        }

        return result.message
    }

    /**
     * Logout a currently logged in admin user 
     * @returns succesfuly logout
     */
    async function signout() {
        const url = '/api/admin/logout'

        const result = await api.post(url)

        //errors 
        const { detail } = result
        if (detail) {
            throw new Error(detail)
        }

        return result
    }

    /**
     * Get the currently logged 
     */
    async function getCurrentUser() {
        const url = '/api/scrapery/user'

        return await api.get(url)
    }

    /**
     * Update user profile information 
     * 
     * @param {object} user user information 
     * @returns success or failure
     */
    async function updateUserInfo(user) {
        const url = "/api/admin/users/info"

        const { id, first_name, last_name } = user
        const data = new FormData()

        data.append('id', id)
        data.append('first_name', first_name)
        data.append('last_name', last_name)

        return await api.put(url, data)
    }

    async function updateUserPassword(user) {
        const url = "/api/admin/users/password"
        const { id, password, password_confirm } = user

        const data = new FormData()
        data.append('id', id)
        data.append('password', password)
        data.append('password_confirm', password_confirm)

        return await api.put(url, data)
    }
}

export default AuthAPI